<template>
	<b-container class="w-75 text-dark m-auto p-0">
		<b-row no-gutters class="text-center">
			<transition name="fade" key="transition.virtapp.launch" appear>
				<b-col>
					<template v-if="stack && streamingURL">
						<b-button :href="streamingURL" variant="outline-primary">Click to launch {{ stack.stackName }}</b-button>
					</template>
					<template v-else-if="stack && !streamingURL">
						<RingLoader :color="'#343a40'" :size="64" :loading="true" class="m-auto py-5" />
						Getting link for {{ stack.stackName }}
					</template>
					<ErrorModal :modalData="{ message: 'We\'re sorry! You don\'t appear to have access to this resource. Please contact your school\'s help desk.', visible: true, allowClose: false }" v-else />
				</b-col>
			</transition>
		</b-row>
	</b-container>
</template>

<script>
	import { RingLoader } from '@saeris/vue-spinners';
	import stateMessages from '@/components/Desktop/stateMessages';
	
	export default
	{
		name: 'virtapp-launch',
		components: { RingLoader },
		props: [ 'stack' ],
		computed:
		{
			portalAPI: function()
			{
				return this.$root.$refs.app.portalAPI;
			}
		},
		methods:
		{
			launch: async function()
			{
				let result = await this.portalAPI.get(
						'/virtapp/' + this.stack.stackUUID + '/link',
						((this.$route.query) ? { params: this.$route.query } : undefined)
					)
					.then(
						resp => resp.data
					).catch(e => this.$logger.error(e));
				
				this.$logger.debug(result);
				
				if('StreamingURL' in result)
				{
					this.streamingURL = result.StreamingURL;
					
					window.location.href = this.streamingURL;
				}
			},
			stateMessage: function(state)
			{
				return ((state in stateMessages) ? stateMessages[state] : Object.assign(stateMessages['_DEFAULT'], { message: 'State: ' + state }));
			}
		},
		mounted()
		{
			if(this.stack)
				this.$nextTick(this.launch);
		},
		data() { return { streamingURL: undefined }; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container
	{
		height: 100%;
		max-height: 100%;
		
		overflow: auto;
		
		padding: 12px;
	}
	
	.fade-enter-active, .fade-leave-active
	{
		transition: all 1s;
	}
</style>
